import {
  OpenIdConnectApi,
  ProfileInfoApi,
  BackstageIdentityApi,
  SessionApi,
} from '@backstage/core-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';
import {
  createApiRef,
  configApiRef,
  discoveryApiRef,
  oauthRequestApiRef,
  ApiBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';

// BST-024: frontend half of the ZITADEL OIDC wiring (backend half is
// packages/backend/src/extensions/auth.ts). `provider.id: 'oidc'` here MUST match the
// `providerId: 'oidc'` registered on the backend - that's how the two sides connect; the
// `auth.zitadel`/`zitadel-auth-provider` ids below are purely frontend-local labels and can
// be anything.
const zitadelAuthApiRef = createApiRef<
  OpenIdConnectApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
>().with({
  id: 'auth.zitadel',
});

const zitadelAuthApi = ApiBlueprint.make({
  name: 'zitadel',
  params: defineParams =>
    defineParams({
      api: zitadelAuthApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        oauthRequestApi: oauthRequestApiRef,
        configApi: configApiRef,
      },
      factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
        OAuth2.create({
          configApi,
          discoveryApi,
          oauthRequestApi,
          environment: configApi.getOptionalString('auth.environment'),
          provider: {
            id: 'oidc',
            title: 'ZITADEL',
            icon: () => null,
          },
          defaultScopes: ['openid', 'profile', 'email'],
        }),
    }),
});

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      (
        <SignInPage
          {...props}
          provider={{
            id: 'zitadel-auth-provider',
            title: 'ZITADEL',
            message: 'Sign in with your XData account',
            apiRef: zitadelAuthApiRef,
          }}
        />
      ),
  },
});

export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [zitadelAuthApi, signInPage],
});

export default authModule;
